import {inject, injectable} from "inversify"
import SERVICE_IDENTIFIER from "../constants/identifiers"
import SystemConfig, {CONFIG_PARAMS} from "./SystemConfig"
import events from "../events/EventsObservable"
import {EVENTS} from "../events/baseEvents"
import {ACTION_EVENTS} from "../ui/UserAction"
import {GAME_EVENTS} from "../game/gameEvents"
import Wallet from "../wallet/Wallet"
import AbstractAudio from "../engine/AbstractAudio"
import {REELS_EVENTS} from "../game/slot/reelsEvents"
import StatesManager from "../states/StatesManager"
import {STATES} from "../states/states"
import {isInIframe} from "../helpers"
import {FULLSCREEN_EVENTS} from "../ui/screen/Fullscreen";

@injectable()
export default class PostMessages {

    protected config: SystemConfig
    protected wallet: Wallet
    protected audio: AbstractAudio
    protected states: StatesManager

    protected origin: string
    protected active: boolean = false

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: AbstractAudio,
        @inject(SERVICE_IDENTIFIER.StatesManager) states: StatesManager
    ) {
        this.config = config
        this.wallet = wallet
        this.audio = audio
        this.states = states

        // this.origin = isLocalhost() ? '*' : origin
        this.origin = '*'
        this.active = this.config.get(CONFIG_PARAMS.POST_MESSAGES)
    }

    isActive(): boolean {
        return this.active
    }

    init() {
        if (this.isActive()) {
            // Start listen to postMessages from parent
            window.addEventListener('message', message => {
                this.handleMessage(message)
            })

            // subscribe to events
            events.subscribe(EVENTS.GAME_LOAD_SUCCESS, () => {
                this.postMessage('game.loaded', {'gameOrigin': origin})
            })
            events.subscribe(ACTION_EVENTS.ACTION_HISTORY_OPEN, () => {
                this.postMessage('game.goto.history')
            })
            events.subscribe(GAME_EVENTS.GAME_START_ROUND, () => {
                this.postMessage('game.round.started')
            })
            events.subscribe(GAME_EVENTS.GAME_END_ROUND, () => {
                this.postMessage('game.round.ended')
            })
            events.subscribe(REELS_EVENTS.REELS_START, () => {
                this.postMessage('game.spin.started')
            })
            events.subscribe(REELS_EVENTS.REELS_COMPLETE, () => {
                this.postMessage('game.spin.ended')
            })

            if (this.config.get(CONFIG_PARAMS.FULLSCREEN) === true && isInIframe()) {
                events.subscribe(ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST, () => {
                    this.postMessage('game.fullscreen.enter')
                    events.dispatch(FULLSCREEN_EVENTS.FULLSCREEN_CHANGE, {inFullscreen: true})
                })
                events.subscribe(ACTION_EVENTS.ACTION_FULLSCREEN_EXIT_REQUEST, () => {
                    this.postMessage('game.fullscreen.exit')
                    events.dispatch(FULLSCREEN_EVENTS.FULLSCREEN_CHANGE, {inFullscreen: false})
                })
            }
        }
    }

    postMessage(method: string, data: any = undefined) {
        window.parent.postMessage({
            "method": method,
            "data": data
        }, this.origin)
    }

    handleMessage(message: any) {
        switch(message?.data?.method) {
            case "gel.balance.reload":
                this.wallet.reloadBalance()
                break
            case "gel.autoPlay.stop":
                events.dispatch(ACTION_EVENTS.ACTION_AUTOSTART_STOP)
                break
            case "gel.gamePlay.stop":
                this.states.setState(STATES.ERROR)
                this.states.lock()
                break
            case "gel.gamePlay.resume":
                this.states.unlock()
                this.states.setState(STATES.IDLE)
                break
            case "gel.audio.enable":
                this.audio.unmute()
                break
            case "gel.audio.mute":
                this.audio.mute()
                break
            default:
                break
        }
    }

    handleWalletMessage(data: Array<string>|string) {
        if (Array.isArray(data)) {
            for (let msg of data) {
                this.postMessage("game.handleWalletMessage", {'message': msg})
            }
        } else {
            this.postMessage("game.handleWalletMessage", {'message': data})
        }
    }
}
